import commonUtils from '@/utils/commonUtils'
import './customerComment.css' // CSS 파일 import
import {
  adminDelYn,
  CommentListItem,
  withDrawnCumtomer,
} from '@/pages/board/boardItem'
type ModalAction = 'insert' | 'delete' | 'update'

interface CommentProps {
  commentList: CommentListItem[]
  handleCommentAction?: (action: ModalAction, item?: any) => void
  isAuthenticated: boolean
  userCstId?: string
  isMobile: boolean
}

export const CustomerComment: React.FC<CommentProps> = ({
  commentList,
  handleCommentAction,
  isAuthenticated,
  userCstId,
  isMobile,
}) => {
  return (
    <>
      {!isMobile ? (
        <>
          {commentList.map((item) => {
            const isMine = isAuthenticated && userCstId === item.cstId
            return (
              <div
                key={item.commentSn}
                className={`chat-container ${isMine ? 'right' : 'left'}`}
              >
                {!isMine && (
                  <div className="avatar" style={{ marginRight: '10px' }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </div>
                )}

                <div
                  className="speech-bubble"
                  style={{
                    border: `${isMine ? '1px solid #d09d30' : '1px solid #f1f1f1'}`,
                    padding: '10px',
                    borderRadius: '10px',
                    color: `${isMine ? '#d09d30' : '#333'}`,
                  }}
                >
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <div className="chat-title" style={{ fontWeight: 'bold' }}>
                      {item.withDrawYn === 'Y'
                        ? withDrawnCumtomer.name
                        : item.nickName}
                    </div>
                    <div>{commonUtils.formatDate(item.regDate, true)}</div>
                  </div>
                  <div className="chat-content">
                    {item.adminDelYn === 'Y'
                      ? adminDelYn.contents
                      : item.withDrawYn === 'Y'
                        ? withDrawnCumtomer.contents
                        : item.commentCn}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'right',
                      color: '#979797',
                      cursor: 'pointer',
                    }}
                  >
                    {isMine && (
                      <div
                        onClick={() =>
                          handleCommentAction?.('delete', item.commentSn)
                        }
                        style={{
                          color: '#d09d30',
                        }}
                      >
                        삭제
                      </div>
                    )}
                  </div>
                </div>
                {isMine && (
                  <div
                    className="avatar"
                    style={{ marginLeft: '10px', backgroundColor: '#d09d30' }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </div>
                )}
              </div>
            )
          })}
        </>
      ) : (
        <div className="comments-list">
          {commentList.map((comment) => {
            const isMine = isAuthenticated && userCstId === comment.cstId
            return (
              <div key={comment.commentSn} className="comment-item">
                <div className="comment-author">
                  {/* <div className="comment-avatar">
              {comment.nickName.charAt(0)}
            </div> */}
                  <span className="comment-author-name">
                    {comment.nickName}
                  </span>
                  <span className="comment-date">
                    {commonUtils.formatDate(comment.regDate, true)}
                  </span>
                </div>
                <div className="comment-content">{comment.commentCn}</div>
                {isMine && (
                  <div
                    onClick={() =>
                      handleCommentAction?.('delete', comment.commentSn)
                    }
                    style={{
                      color: '#d09d30',
                      textAlign: 'right',
                      fontSize: '0.8rem',
                      fontWeight: 'bold',
                    }}
                  >
                    삭제
                  </div>
                )}
              </div>
            )
          })}
        </div>
      )}
    </>
  )
}
